import { createSlice } from "@reduxjs/toolkit";

export const placeAppointmentSlice = createSlice({
  name: "placeAppointment",
  initialState: {
    doctor: {},
    session: {},
    service : {}
  },
  reducers: {
    setDoctor: (state, action) => {
      state.doctor = action.payload;
    },
    setSession: (state, action) => {
      state.session = action.payload;
    },
    setService: (state, action) => {
      state.service = action.payload;
    },
  },
});

export const { setDoctor, setSession, setService } = placeAppointmentSlice.actions;

export default placeAppointmentSlice.reducer;
